import React from 'react';
import type { Application, Route } from '../../types';
import type { ApplicationDocumentRow } from '../../utils/applicationDocumentRegistry';
import { ClosingPackageWorkspace } from '../../features/closingPackage';

/**
 * Host mount point for Closing Package on Application Documents tab.
 * FE-002: thin wrapper → ClosingPackageWorkspace (feature module).
 * Legacy props (routes/allRows/preview/download) retained for host compatibility;
 * composition UI returns in FE-006+.
 */
export type ClosingPackageBlockProps = {
  application: Application;
  routes: Route[];
  allRows: ApplicationDocumentRow[];
  onPreview: (row: ApplicationDocumentRow) => void;
  onDownload: (row: ApplicationDocumentRow) => void;
  onRefreshDocuments: () => void;
};

const ClosingPackageBlock: React.FC<ClosingPackageBlockProps> = ({
  application,
  onRefreshDocuments,
}) => (
  <ClosingPackageWorkspace
    applicationId={application.id}
    onRefreshDocuments={onRefreshDocuments}
  />
);

export default ClosingPackageBlock;
